import React from "react";
import { Popconfirm, Select } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashCan } from "@fortawesome/free-solid-svg-icons";
import { CfOperators } from "../../../../../apis/cfOperators";
import PRZAdvanceFilterCustomInputs from "./PRZAdvanceFilterCustomInputs";
import dayjs from "dayjs";
import "./style.scss";
import PRZSelect from "../../../UI/PRZSelect";

const { Option } = Select;

const Rule = ({
  rule,
  updateRule,
  removeRule,
  customFieldOptions,
  groupType,
  ruleIndex,
}) => {
  const handleFieldChange = (fieldId) => {
    const selectedCF = customFieldOptions?.find(
      (cfOption) => cfOption?.cf_id === fieldId
    );

    const selectedField = CfOperators?.field_types?.find(
      (fieldType) => fieldType?.type === selectedCF?.field_type
    );

    let defaultData = [];

    if (selectedCF?.field_type === "DROPDOWN") {
      defaultData = selectedCF?.default_data ?? [];
    } else if (selectedCF?.field_types === "ATTACHMENT") {
      defaultData = ["true", "false"];
    }

    updateRule({
      ...rule,
      cf_id: fieldId,
      cf_entity_id: selectedCF?.cf_entity_id,
      field_type: selectedField?.type,
      fieldOperators: selectedField?.operators,
      operator: selectedField?.operators?.[0]?.value,
      values: "",
      placeholder: "",
      input_type: selectedField?.operators?.[0]?.input_type,
      dropdownOptions: defaultData,
    });
  };

  const handleOperatorChange = (val) => {
    const selectedOperator = rule?.fieldOperators?.find(
      (item) => item?.value === val
    );

    updateRule({
      ...rule,
      operator: val,
      placeholder: selectedOperator?.placeholder,
      input_type: selectedOperator?.input_type,
    });
  };

  const handleValueChange = (value, fieldType, inputType, i) => {
    let newValue = [];
    if (["NUMBERS", "NUMBER"].includes(fieldType) && inputType === "range") {
      newValue = i === 0 ? [value, rule.values[1]] : [rule.values[0], value];
    } else if (fieldType === "DATE" && inputType === "range") {
      newValue = [...value];
    } else {
      newValue = [value];
    }
    updateRule({ ...rule, values: newValue });
  };

  const groupLabel = () => {
    let label = "And";
    if (groupType === "AND" && ruleIndex === 0) {
      label = "Only continue if";
    } else if (groupType !== "AND" && ruleIndex === 0) {
      label = "Or continue if";
    } else {
      label = "And";
    }
    return label;
  };

  return (
    <div className="advance-filter__rule__wrapper">
      <div className="rule-head__row">
        <div>{groupLabel()}</div>
        <Popconfirm
          title="Are you sure you want to remove this Rule?"
          onConfirm={removeRule}
        >
          <div className="delete-line-button__new">
            <FontAwesomeIcon icon={faTrashCan} />
          </div>
        </Popconfirm>
      </div>

      <div className="rule-input__row">

        <div className="rule-input__row-left">
          <PRZSelect
            wrapperClassName="rule-select__wrapper"
            className="rule-select-cf"
            value={rule.cf_id}
            options={customFieldOptions?.map((item) => ({
              ...item,
              value: item?.cf_id,
              label: item?.field_name,
              tag: item?.field_type,
            }))}
            placeholder="Select a Field"
            size="middle"
            defaultValue="Select Field"
            onChange={handleFieldChange}
            showSearch
          />
          {rule?.fieldOperators && (<PRZSelect
            wrapperClassName="rule-select__wrapper"
            className="rule-select-operator"
            value={rule.operator}
            options={
              rule?.fieldOperators
                ? rule?.fieldOperators?.map((item) => ({
                    ...item,
                    value: item?.value,
                    label: item?.label,
                  }))
                : null
            }
            placeholder="Select Operator"
            size="middle"
            defaultValue="Select Operator"
            onChange={handleOperatorChange}
          />)}
        </div>

        <div className="rule-input__row-right">
          {rule?.input_type !== "none" && (
            <PRZAdvanceFilterCustomInputs
              type="text"
              wrapperClassName="rule-input__wrapper"
              className="rule-input"
              entityType={rule?.field_type}
              inputType={rule?.input_type}
              placeholder={rule?.placeholder}
              inputClassName="orgFormInput"
              onChange={(val, i) =>
                handleValueChange(val, rule?.field_type, rule?.input_type, i)
              }
              value={rule?.field_type === 'DATE' && rule?.values?.length > 0 ? rule?.values?.map((value) => dayjs(value)) : rule.values}
              disabled={!rule.operator}
              dropdownOptions={rule.dropdownOptions}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default Rule;
